import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { DropdownList } from '../../../Components/DropdownList/index.js';
export const PlaceholdersDropdownItem = ({ item, onClick }) => {
    const handleClick = useCallbackRef(() => {
        onClick(item);
    });
    return (_jsx(DropdownList.DropdownItem, { onClick: handleClick, dataTestId: `placeholder-${item}`, children: item }));
};
